<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form @submit.prevent="handleSubmit(submitForm)">
      <div class="space-y-4">
        <div>
          <ValidationProvider
            name="content"
            vid="content"
            rules="required"
            v-slot="{ errors, failed }"
            slim
          >
            <BaseFormGroup class="w-full">
              <BaseFormTextarea
                v-model="data.content"
                rows="5"
                :disabled="pending"
                :invalid="failed"
              />
              <BaseFormInlineMessage v-if="failed" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </ValidationProvider>
        </div>

        <button class="btn btn-brand" :disabled="invalid || pending">Submit</button>

        <slot />
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

const DEFAULT_COMMENT = {
  content: '',
};

export default {
  mixins: [veeValidateErrorsMixin],

  props: {
    submitAction: {
      type: Function,
      default: () => Promise.reject(Error('submitAction in not defined')),
    },
    comment: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      pending: false,
      data: { ...DEFAULT_COMMENT },
    };
  },

  created() {
    this.resetForm();
  },

  methods: {
    resetForm() {
      this.data = {
        ...DEFAULT_COMMENT,
        ...(this.comment || {}),
      };
    },
    async submitForm() {
      this.pending = true;

      try {
        await this.submitAction(JSON.parse(JSON.stringify(this.data)));
        this.$emit('submit:resolved');
      } catch (error) {
        if (error.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.observer = this.$refs.observer;
          this.addServerErrors(error.data.errors);
        }
        this.$emit('submit:rejected');
      }
      this.pending = false;
    },
  },
};
</script>
